import { t } from "@lingui/macro";
import { useAtomValue, useSetAtom } from "jotai";
import { v4 as uuidv4 } from "uuid";

import { Crementor } from "@whoosh/design-system/src/components/controls/Crementor";
import { Avatar } from "@whoosh/design-system/src/components/display";
import { Text, HStack } from "@whoosh/design-system/src/components/primitive";

import { addPlayerAtom } from "../../../../atoms/actions/addPlayer/addPlayerAtom";
import { removePlayerAtom } from "../../../../atoms/actions/removePlayer/removePlayerAtom";
import { BookingWizardDataAtom } from "../../../../atoms/stores";
import { BookingWizard } from "../../../../types";

export const MemberHoldCounter = ({
  capacityOnBooking,
  rounds: activeRounds,
}: {
  capacityOnBooking: number;
  rounds?: BookingWizard.BaseRound[];
}) => {
  const bookingWizardData = useAtomValue(BookingWizardDataAtom);

  const rounds = activeRounds ?? bookingWizardData?.rounds ?? [];

  const memberHoldPlayers = rounds.filter(
    (round) => round.player.clientType === "memberHold"
  );
  const maxPlayers = capacityOnBooking ?? 4;

  const totalHolds = memberHoldPlayers.length;
  const memberHoldMaximum =
    maxPlayers -
    rounds.filter(
      (round) =>
        round.player.clientType !== "memberHold" &&
        !(round.player.clientType === "member" && round.player.nonPlayingHost)
    ).length;

  const nextHoldToRemove =
    memberHoldPlayers.length > 0 ? memberHoldPlayers[0]?.player.id ?? "" : "";

  const addPlayer = useSetAtom(addPlayerAtom);
  const removePlayer = useSetAtom(removePlayerAtom);

  return bookingWizardData?.type !== "LessonBooking" &&
    bookingWizardData?.canAddMemberHold ? (
    <HStack
      px={6}
      justifyContent="space-between"
      alignItems="center"
      opacity={totalHolds >= memberHoldMaximum ? 0.5 : 1}
      py={2}
      my={2}
    >
      <HStack alignItems="center" gap={4}>
        <Avatar type="member" size="sm" useIcon />
        <Text
          maxFontSizeMultiplier={2}
          variant="mainBaseMedium"
        >{t`Member Hold`}</Text>
      </HStack>
      <Crementor
        min={0}
        max={memberHoldMaximum}
        value={totalHolds}
        onIncrement={() => {
          addPlayer({
            clientType: "memberHold",
            id: uuidv4(),
            firstName: "",
            lastName: "",
            profileImagePublicId: null,
          });
        }}
        onDecrement={() => {
          if (!!nextHoldToRemove) {
            removePlayer(nextHoldToRemove);
          }
        }}
      />
    </HStack>
  ) : null;
};
